// Import model
import { ObjectTypeCondition } from '../models/ObjectTypeCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ObjectTypeIndexedFields } from '../models/ObjectTypeIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ObjectTypeIndexedFieldsSerializer } from './ObjectTypeIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ObjectTypeCondition - handles JSON serialization and deserialization with type validation
 */
export class ObjectTypeConditionSerializer {
  /**
   * Deserializes a JSON string into a ObjectTypeCondition instance
   */
  static deserialize(json: string): ObjectTypeCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ObjectTypeCondition instance
   */
  static fromObject(obj: any): ObjectTypeCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ObjectTypeCondition');
    }


    const instance: ObjectTypeCondition = {
      fieldName: obj['fieldName'] as ObjectTypeIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ObjectTypeCondition instances
   */
  static deserializeArray(json: string): ObjectTypeCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ObjectTypeCondition instance to a JSON string
   */
  static serialize(instance: ObjectTypeCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ObjectTypeCondition instance to a plain object
   */
  static toObject(instance: ObjectTypeCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ObjectTypeCondition instances to a JSON string
   */
  static serializeArray(instances: ObjectTypeCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
